export default "__VITE_ASSET__BbgzUIt3__"